import apiClient from '../utils/apiClient';

class PaymentService {
    async createSubscription(plan) {
        const response = await apiClient.post('/payments/subscribe', { plan });
        return response;
    }

    async verifySubscription(verificationData) {
        const response = await apiClient.post('/payments/verify-subscription', verificationData);
        return response;
    }

    async changePlan(plan) {
        const response = await apiClient.patch('/payments/subscription/plan', { plan });
        return response;
    }

    async cancelSubscription() {
        const response = await apiClient.post('/payments/subscription/cancel', {});
        return response;
    }

    async abandonCheckout() {
        const response = await apiClient.post('/payments/subscription/abandon-checkout', {});
        return response;
    }

    async getPaymentHistory({ limit = 20, skip = 0 } = {}) {
        const response = await apiClient.get('/payments/history', {
            params: { limit, skip },
        });
        return response;
    }
}

const paymentService = new PaymentService();
export default paymentService;
